export default {
  devStoreConfig: false,
  api: {
    default: 'https://infinite-fjord-46165.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: true,
  }
};



// WEBPACK FOOTER //
// ./config/config.client14.js